import {gql} from '@apollo/client';

const CREATE_COUNTRY_COST_ENTRY_YEAR = gql`
  mutation createCountryCostEntryYear($countryId: ID!) {
    createCountryCostEntryYear(countryId: $countryId) {
      year
      busCostEntry {
        adblueCost
        cleaningCost
        currency
        dieselCost
        flixStandardCost
        legalCost
        lngCost
        otherCost
        overheadCost
        repairCostPerDistanceUnit
        repairCostPerMonth
        tiresCost
        year
      }
      busTypeCostEntries {
        id
        busTypeId
        year
        customIdentifier
        insuranceCost
        interestCost
        leasingCost
        maintenanceCostPerMonth
        maintenanceCostPerDistanceUnit
        motorVehicleTax
        vehicleProductionYear
      }
      driverCostEntry {
        accommodationCostPerNight
        dailyAllowance
        daytimeWeekdaysWorkingHourCost
        daytimeWeekendsWorkingHourCost
        nighttimeWeekdaysWorkingHourCost
        nighttimeWeekendsWorkingHourCost
        prefilledEmptyDistance
        prefilledEmptyHr
        replacementCostPerHr
        year
        replacementCostPerKm
      }
      qualityChecked
    }
  }
`;

export default CREATE_COUNTRY_COST_ENTRY_YEAR;
